import List from '.';
import { Space, Switch, Tooltip } from 'antd';
import { cutLongText, formatCurrency, formatCurrencyToExport } from '../../../services/utils';
import moment from 'moment';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

export default function ControlSuppliersPage(props: any) {
    const [changeWasPaid, setChangeWasPaid] = useState<{ value: boolean, id: number } | undefined>(undefined);

    const calculateValue = (record: any, formatted = true) => {
        if (formatted) {
            return formatCurrency(record?.value_table || 0);
        }

        return record?.value_table || 0;
    };

    const columns: any[] = [
        { title: 'Fornecedor', dataIndex: ['supplier', 'data', 'name'], key: 'supplier' },
        {
            title: 'Data', dataIndex: 'start', key: 'start', sorter: true,
            render: (_: any, record: any) => record.start ? moment(record.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
        },
        {
            title: 'Pick-up', dataIndex: 'pickup_location', key: 'pickup_location',
            render: (_: any, record: any) => (cutLongText(record?.pickup_location, 20)),
        },
        {
            title: 'Drop-off', dataIndex: 'dropoff_location', key: 'dropoff_location', sorter: true,
            render: (_: any, record: any) => (cutLongText(record?.dropoff_location, 20)),
        },
        {
            title: 'Pax Grupo', dataIndex: 'pax_group', key: 'pax_group', sorter: false,
            render: (_: any, record: any) => record?.booking?.data?.pax_group,
        },
        {
            title: 'Cliente', dataIndex: 'client_name', key: 'client_name', sorter: true,
            render: (_: any, record: any) => cutLongText(record?.booking?.data?.client_name, 40)
        },
        {
            title: 'Valor da Reserva', dataIndex: 'value_table', key: 'value_table', sorter: true,
            render: (_: any, record: any) => calculateValue(record)
        },
        {
            title: 'Pagamento', dataIndex: 'was_paid', key: 'was_paid', sorter: true, width: 170,
            render: (_: any, record: any) => {
                return (<Tooltip title={record.was_paid ? 'Cancelar confirmação' : 'Confirmar pagamento'}>
                    <Space direction={isMobile ? 'vertical' : 'horizontal'}>
                        <Switch checked={record.was_paid}
                            style={{ marginRight: 10 }}
                            onChange={(event: boolean) => {
                                setChangeWasPaid({ value: event, id: record.id });

                                record.was_paid = event;
                            }} />
                        {record.was_paid ? 'Pago' : 'Não Pago'}
                    </Space>
                </Tooltip>);
            }
        }
    ];

    const label = 'Fornecedores';
    const workerFilter = 'filter_supplier_id';

    const onMapDataToExport = (data: any) => {
        let total = 0;

        const dados = data.map((service: any) => {
            total += calculateValue(service.data, false);

            return {
                'ID': service.data.id,
                'Fornecedor': service?.relationships?.supplier?.data?.name,
                'Data': service?.data?.start ? moment(service.data.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
                'Pick-up': service.data.pickup_location,
                'Drop-off': service.data.dropoff_location,
                'Pax Grupo': service?.relationships?.booking?.data?.pax_group,
                'Cliente': service?.relationships?.booking?.data?.client_name,
                'Pagamento': service?.data?.was_paid ? 'Pago' : 'Não Pago',
                'Valor': formatCurrencyToExport(calculateValue(service.data, false)),
            };
        });

        return dados.concat([{
            'ID': '',
            'Fornecedor': '',
            'Data': '',
            'Pick-up': '',
            'Drop-off': '',
            'Pax Grupo': '',
            'Cliente': '',
            'Pagamento': 'TOTAL',
            'Valor': Number(total)
        }]);
    };

    return (
        <div className="content_page">
            <List
                type="suppliers"
                label={label}
                workerFilter={workerFilter}
                columns={columns}
                onMapDataToExport={onMapDataToExport}
                changeWasPaid={changeWasPaid}
                calculateValue={calculateValue} />
        </div>
    )
}
